import { PageLayout } from '../../PageLayout';
import { LiveboardWrapper } from './LiveboardWrapper';

export const ThoughtspotPocPage = () => {
  return (
    <PageLayout className="flex flex-col overflow-hidden">
      <LiveboardWrapper />
    </PageLayout>
  );
};
